import { render, staticRenderFns } from "./smsConfig.vue?vue&type=template&id=681482cd&scoped=true"
import script from "./smsConfig.vue?vue&type=script&lang=js"
export * from "./smsConfig.vue?vue&type=script&lang=js"
import style0 from "./smsConfig.vue?vue&type=style&index=0&id=681482cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681482cd",
  null
  
)

export default component.exports